var image_viewer_default = {
  "fontElementMap": "ysQMY",
  "imageContainer": "P7E1-",
  "expandButton": "KFpTH",
  "expandIcon": "dD4Ub",
  "pointer": "T7Y2y",
  "imageWrapper": "klqc-",
  "imageRatio": "x9uQ7",
  "image": "rjVGT",
  "imageOverlay": "ARo7y",
  "imagePreload": "pcFib",
  "imageHighres": "gP6HQ",
  "onlyHighRes": "JO-R4",
  "image_loading": "prhlu"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
